<template>
  <div>
    <div class="bg-load" style="display: none;">
      <div class="preloader-sky"><img src="@/assets/img/default/rocket-banner.png"
          alt="preloader"></div>
    </div>
    <div v-if="btnFlag" id="progress" @click="backTop" class="toTop" style="display: grid;"><span id="valiu"><i class="fas fa-arrow-up"></i></span></div>
    <Top></Top>

    <section class="hero-section">
      <div class="man-left"><img src="@/assets/img/default/left-man.png"
          alt="left-man"></div>
      <div class="globe1"><img src="@/assets/img/default/globe1.png" alt="globe-img">
      </div>
      <div class="globe2"><img src="@/assets/img/default/globe2.png" alt="globe-img">
      </div>
      <div class="globe3"><img src="@/assets/img/default/globe3.png" alt="globe-img">
      </div>
      <div class="dots-left"><img src="@/assets/img/default/dots-left.png"
          alt="dots-left"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xxl-9">
            <div class="hero-content wow fadeInUp" data-wow-delay="0.2s"
              style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
              <h5>全新发卡体验</h5>
              <h1>快捷下单，自动发货</h1>
              <p>提供优质虚拟物品一站式自动交易服务，平台系统功能齐全、便捷好用 是您自动发卡需求的最佳解决方案</p>
              <p>诚邀steam平台和Origin平台游戏道具皮肤资源、软件授权码资源实力商家合作入驻</p>
              <div class="banner-cmn">
                <a  :href="merchantUrl"
                  class="cmn--btn">
                  <span>立即入住，成为商户</span></a>
                  <a
                  :href="merchantUrl"
                  class="cmn--border"><span>注册</span></a>
                  </div>
            </div>
            <div class="hero-thumb">
              <img src="@/assets/img/default/middle.png" alt="hero-img">
              <a href="" class="video-btn">
                <i class="fas fa-play"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="light"><img src="@/assets/img/default/light.png" alt="light-img">
      </div>
      <div class="dots-right"><img src="@/assets/img/default/dots-right.png"
          alt="dots-right"></div>
      <div class="man-right"><img src="@/assets/img/default/right-man.png"
          alt="left-man"></div>
      <div class="bottom-shape"><img src="@/assets/img/default/bottom-shape.png"
          alt="-banner-shape"></div>
    </section>
    <section class="smart-section pt-120 pb-120">
      <div class="container">
        <div class="row">
          <div class="col-xl-9 offset-xl-3">
            <div class="smart-wrapper">
              <div class="row">
                <div class="col-xl-9">
                  <div class="section-header section-center wow fadeInDown" data-wow-delay="0.3s"
                    style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInDown;">
                    <h5 class="section-cete">发卡平台</h5>
                    <h2 class="section-title">平台优势
                    </h2>
                    <p>
                      为商户及其买家提供，便捷、绿色、安全、快速的销售和购买体验。
                    </p>
                  </div>
                </div>
              </div>
              <div class="row g-4 justify-content-center">
                <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-delay="0.4s"
                  style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">
                  <div class="smart-items">
                    <div class="thumb">
                      <img src="@/assets/img/default/smart1.png"
                        alt="smart-img">
                    </div>
                    <div class="content">
                      <h4>
                        <a href="sign.html">资金保障</a>
                      </h4>
                      <p>
                        商户的资金，全是次日结算当天到账，资金平均停留时间不超过12小时，资金安全将得到充分的保障。</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-delay="0.6s"
                  style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
                  <div class="smart-items smart-items-two">
                    <div class="thumb"><img
                        src="@/assets/img/default/smart2.png"
                        alt="smart-img"></div>
                    <div class="content">
                      <h4><a
                          href="sign.html">费率超低</a>
                      </h4>
                      <p>支付渠道直接对接官方，直接去掉中间商的差价，因此我们可以给商户提供更低廉的费率。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-delay="0.8s"
                  style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInUp;">
                  <div class="smart-items smart-items-three">
                    <div class="thumb">
                      <img src="@/assets/img/default/smart3.png"
                        alt="smart-img">
                    </div>
                    <div class="content">
                      <h4>
                        <a
                          href="sign.html">服务器安全</a>
                      </h4>
                      <p>
                        采用群集服务器，防御高遍布全球，无论用户身在何处，均能获得流畅安全可靠的体验。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smart-man"><img src="@/assets/img/default/smart.png"
          alt="smart-img"></div>
      <div class="smart-two"><img src="@/assets/img/default/smarttwo.png"
          alt="smart-img"></div>
      <div class="rocket"><img src="@/assets/img/default/smart4.png" alt="rocket">
      </div>
    </section>
    <!-- <section class="counter-section pt-120 pb-120">
      <div class="count-top-shape"><img src="@/assets/img/default/shape-top.png"
          alt="counter-shape"></div>
      <div class="container">
        <div class="section-header section-center wow fadeInDown" data-wow-delay="0.3s"
          style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInDown;">
          <h2 class="section-title text-white">诚信运营深受好评</h2>
        </div>
        <div class="counter-wrapper">
          <div class="row g-4">
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInLeft" data-wow-delay="0.2s"
              style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft;">
              <div class="counter-items odometer-item">
                <div class="counter-content">
                  <div class="cont d-flex align-items-center">
                    <h2 class="odometer odometer-auto-theme" data-odometer-final="700">
                      <div class="odometer-inside"><span class="odometer-digit"><span
                            class="odometer-digit-spacer">8</span><span
                            class="odometer-digit-inner"><span class="odometer-ribbon"><span
                                class="odometer-ribbon-inner"><span
                                  class="odometer-value">3w+</span></span></span></span></span>
                      </div>
                    </h2>
                    <h2>+</h2>
                  </div>
                </div>
                <p>商户</p>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInLeft" data-wow-delay="0.4s"
              style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInLeft;">
              <div class="counter-items odometer-item">
                <div class="counter-content">
                  <div class="cont d-flex align-items-center">
                    <h2 class="odometer odometer-auto-theme" data-odometer-final="250">
                      <div class="odometer-inside"><span class="odometer-digit"><span
                            class="odometer-digit-spacer">8</span><span
                            class="odometer-digit-inner"><span class="odometer-ribbon"><span
                                class="odometer-ribbon-inner"><span
                                  class="odometer-value">100W+</span></span></span></span></span>
                      </div>
                    </h2>
                    <h2>+</h2>
                  </div>
                </div>
                <p>订单数</p>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInLeft" data-wow-delay="0.8s"
              style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInLeft;">
              <div class="counter-items odometer-item">
                <div class="counter-content">
                  <div class="cont d-flex align-items-center">
                    <h2 class="odometer odometer-auto-theme" data-odometer-final="12">
                      <div class="odometer-inside"><span class="odometer-digit"><span
                            class="odometer-digit-spacer">8</span><span
                            class="odometer-digit-inner"><span class="odometer-ribbon"><span
                                class="odometer-ribbon-inner"><span
                                  class="odometer-value">3年+</span></span></span></span></span>
                      </div>
                    </h2>
                    <h2>+</h2>
                  </div>
                </div>
                <p>合作年限</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="globe-shape"><img src="@/assets/img/default/globe.png"
          alt="globe-img"></div>
      <div class="count-bottom-shape"><img src="@/assets/img/default/shape-bottom.png"
          alt="counter-shape"></div>
    </section> -->

    <section class="process-section pt-120 pb-120 m-none">
      <div class="container"  >
        <div class="row align-items-center justify-content-between flex-row-reverse">
          <div class="col-xl-6" style="width: 54%;">
            <div class="process-content w-1600">
              <div class="section-header wow fadeInDown" data-wow-delay="0.3s"
                style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInDown;">
                <h5 class="section-cete">极致发卡平台</h5>
                <h2 class="section-title">我们的发卡流程</h2>
                <p>专注于发卡行业，专业解决商户难点</p>
              </div>
              <div class="process-slider owl-theme owl-carousel owl-loaded owl-drag">
                <div class="owl-stage-outer">
                  <div class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all 0.6s ease 0s;">
                    <div class="owl-item cloned active" >
                      <div class="process-items">
                        <div class="thumb"><img
                            src="@/assets/img/default/process1.png"
                            alt="process-img"></div>
                        <div class="process-content">
                          <h4><a
                              href="sign.html">申请入驻平台</a>
                          </h4>
                          <p>点击注册/登录，进入注册页面填写信息注册账户，进行入驻</p>
                        </div><span class="badge">1 </span>
                      </div>
                    </div>
                    <div class="owl-item active" >
                      <div class="process-items">
                        <div class="thumb"><img
                            src="@/assets/img/default/process2.png"
                            alt="process-img"></div>
                        <div class="process-content">
                          <h4><a
                              href="sign.html">平台审核成功</a></h4>
                          <p>登录进入商户后台，提交身份信息，商品信息进行审核</p>
                        </div><span class="badge">2 </span>
                      </div>
                    </div>
                    <div class="owl-item active" >
                      <div class="process-items">
                        <div class="thumb"><img
                            src="@/assets/img/default/process2.png"
                            alt="process-img"></div>
                        <div class="process-content">
                          <h4><a
                              href="sign.html">上传商品售卖</a></h4>
                          <p>审核通过后，在商户后台上传所卖商品进行售卖</p>
                        </div><span class="badge">3 </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-5">
            <div class="process-thumb"><img
                src="@/assets/img/default/process-thumb.png"
                alt="process-img"></div>
          </div>
        </div>
      </div>
      <div class="rocket"><img src="@/assets/img/default/smart4.png" alt="rocket">
      </div>
    </section>

    <section class="team-section team-border pt-120 pb-120">
      <div class="team-shape"><img src="@/assets/img/default/shape.png" alt="shape-1">
      </div>
      <div class="team-shape1">
        <img src="@/assets/img/default/shape2.png"
          alt="shape-1">
      </div>
      <div class="container">
        <div class="section-header section-center wow fadeInDown" data-wow-delay="0.3s"
          style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">
          <h5 class="section-cete">结算方式</h5>
          <h2 class="section-title">We Love Our Clients </h2>
          <p>支付宝、网银金额已由系统自动打款到账，如未到账请核实收款信息是否正确，银行卡商户2个小时内到账。</p>
        </div>
        <div class="sponsor-slider owl-theme owl-carousel owl-loaded owl-drag">
          <div class="owl-stage-outer">
            <div class="owl-stage"
              style="transform: translate3d(0, 0px, 0px); transition: all 0.6s ease 0s; width: 1300px;">
              <div class="owl-item cloned" style="width: 199.333px; margin-right: 50px;">
                <div class="sponsor-thumb"><img
                    src="@/assets/img/default/sponsor1.png"
                    alt="sponsor-img"></div>
              </div>
              <div class="owl-item cloned" style="width: 199.333px; margin-right: 50px;">
                <div class="sponsor-thumb"><img
                    src="@/assets/img/default/sponsor2.png"
                    alt="sponsor-img"></div>
              </div>
              <div class="owl-item cloned" style="width: 199.333px; margin-right: 50px;">
                <div class="sponsor-thumb"><img
                    src="@/assets/img/default/sponsor3.png"
                    alt="sponsor-img"></div>
              </div>
              <div class="owl-item cloned" style="width: 199.333px; margin-right: 50px;">
                <div class="sponsor-thumb"><img
                    src="@/assets/img/default/sponsor4.png"
                    alt="sponsor-img"></div>
              </div>
              <div class="owl-item cloned" style="width: 199.333px;">
                <div class="sponsor-thumb"><img
                    src="@/assets/img/default/sponsor5.png"
                    alt="sponsor-img"></div>
              </div>

            </div>
          </div>
          <div class="owl-nav disabled"><button type="button" role="presentation" class="owl-prev"><i
                class="fas fa-arrow-left"></i></button><button type="button" role="presentation"
              class="owl-next"><i class="fas fa-arrow-right"></i></button></div>
          <div class="owl-dots disabled"></div>
        </div>
      </div>
    </section>
    <Search></Search>
    <Bottom></Bottom>
  </div>
</template>

<script>

import Top from './comp/top'
import Bottom from './comp/bottom'
import Search from './comp/search'

export default {
  name: 'IndexDefault',
  components: {Top, Bottom, Search},
  data () {
    return {
      scrollTop: 0,
      btnFlag: false,
      merchantUrl: 'http://jijuxjs.com/merchant/login'
    }
  },
  created () {
		this.merchantUrl = process.env.LOGIN_URL;
		// 推广注册
		if ( this.$route.query.promote ) {
			this.merchantUrl = this.merchantUrl + "?promote=" + this.$route.query.promote;
		}
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },

  computed: {

  },
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    }
  }
}
</script>

<style scoped>
@import '../../assets/style/default/bootstrap.min.css';
@import '../../assets/style/default/odometer.css';
@import '../../assets/style/default/owl.carousel.min.css';
@import '../../assets/style/default/all.min.css';
@import '../../assets/style/default/main.css';
@import '../../assets/style/default/bootstrap.min.css';
@import '../../assets/style/default/m-p.css';
</style>



// WEBPACK FOOTER //
// src/components/default/index.vue